import { queryCache, useMutation } from "react-query";
import { editAccountContacts } from "../../../api/services";
import { useCallback } from "react";

export const useAccountContactsUpdate = (accountNumber: string) => {
  const [mutate, { status, error }] = useMutation(editAccountContacts, {
    onSuccess: async () => {
      await Promise.all([
        queryCache.invalidateQueries(["accounts/contacts", accountNumber]),
        queryCache.invalidateQueries(["accounts/warnings", accountNumber]),
        queryCache.invalidateQueries(["accounts/tickets", accountNumber]),
        queryCache.invalidateQueries([
          "accounts/activities",
          { accountNumber },
        ]),
      ]);
    },
  });
  const editContact = useCallback(
    async (values: Record<string, any>) => {
      // eslint-disable-next-line array-callback-return
      Object.keys(values).forEach(function (key, index) {
        //Convert empty strings to null
        if (
          typeof values[key]?.trim === "function" &&
          values[key]?.trim() === ""
        ) {
          values[key] = null;
        }
      });

      return await mutate({
        accountNumber,
        values,
      });
    },
    [accountNumber, mutate],
  );

  return {
    editContact,
    status,
    error,
  };
};
